/** Western tropical zodiac ranges (month/day, inclusive). */
const ZODIAC_RANGES = [
  { id: "capricorn", from: [12, 22], to: [1, 19] },
  { id: "aquarius", from: [1, 20], to: [2, 18] },
  { id: "pisces", from: [2, 19], to: [3, 20] },
  { id: "aries", from: [3, 21], to: [4, 19] },
  { id: "taurus", from: [4, 20], to: [5, 20] },
  { id: "gemini", from: [5, 21], to: [6, 20] },
  { id: "cancer", from: [6, 21], to: [7, 22] },
  { id: "leo", from: [7, 23], to: [8, 22] },
  { id: "virgo", from: [8, 23], to: [9, 22] },
  { id: "libra", from: [9, 23], to: [10, 22] },
  { id: "scorpio", from: [10, 23], to: [11, 21] },
  { id: "sagittarius", from: [11, 22], to: [12, 21] },
];

function toKey(month, day) {
  return month * 100 + day;
}

/**
 * @param {Date} date
 * @returns {string} zodiac id (aries, taurus, …)
 */
export function getZodiacSign(date) {
  if (!(date instanceof Date) || Number.isNaN(date.getTime())) return null;
  const md = toKey(date.getMonth() + 1, date.getDate());

  for (const { id, from, to } of ZODIAC_RANGES) {
    const start = toKey(from[0], from[1]);
    const end = toKey(to[0], to[1]);
    if (start <= end) {
      if (md >= start && md <= end) return id;
    } else if (md >= start || md <= end) {
      return id;
    }
  }
  return "aries";
}
